import React, { useEffect, useState, useMemo , useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployeeListcreatePersonsListed,
  SetEmployeeProfileDetailsID,
  SetISPendingDetails,
  getSideBarfilesActions,
  SetStatusBTN,
  setThecountBasedRenders,
  setEditableActions,
  setTheoptions,
  setEmployeeListProfileSResponseActions,
  //---forms----
  SetBasiformsID,
  SetAddressId,
  SetJobOfferID,
  SetIdVeriications,
  setBankDetailsId,
  SetEducationDetails,
  SetPreviousEmployeeID,
  setfamliydetailsid,
  SetEsiFormIdActions,
  SetDeclarationId,
  SETBASICFORMcreatedetails,
  setTheUser_ID, //---user_id
  SetSignaturePops,
  settheIDverifycationanotherapidatasResponse, ///---id verifiy responses
  setThefieldAgentbranchactions, ///Branch---List---Outs
  getRoleListActions, ///Role---List
  SetRoleDeleteCalActions,
  setTheemployeeRoleId,
  setTheGrossSalary,
  setTheRoleObjects,
  SettheBracnhId,
  setaRoleChnage,
  setTheRoleRemoveFilters,
  setTheBranchoptionsFieldAgent,
  SetTheDashboardClientList,
  getEmployeeBranchName,
  getEmployeeBranchZones,
  getEmployeeEReuestlist,
  setThePANCARDeportActions,
  resetLimitationActions_opretions,

  ///---counts----zero
  setAadhar_counts,
  setTheAadhar_front_count,
  setTheAadharBack_counts,
  setThPanVerifyCounts,
  setThePanFrontCOunt,
  setbankCounts,
  setTheAllFormPdf,
  setTheZoneObjectinEmployeeList, ///get the----zone
  setThePANCARDotpResponsiveDatas,

  setTheDataAsEncodedDataResponses,
  setTheAadharBackSideImageDatas,
  CreateResponse_store,
  setTheFirstNames,
  settheBankHolderName,
  settheJobinfoBranchEmployeeProfile,
  setthejobinformationroleID,
  setTheApproveRequeststate,
  setTheAadharFrontImageDatas,
  settheSelectedValuesemplist,
  settheSelectedemployeeliststatust,
  setTheAadharFristNumbers,
  setTHnUMBERSRESPONSES,
  setIDverifycationanotherapidatasReponsesError,
  setTablePositionPersist

} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import "../../../StyleSheet/MainComponent/Management/EmployeeList.scss";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import clientimg from "../../../Assets/AppComponent/icons/Client/Vector.svg";
import Regionicons from "../../../Assets/AppComponent/icons/Locationicons/Layer_1 .png";
import empployeeIcons from "../../../Assets/AppComponent/icons/Employee/Group 349.png";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import houseKeeping from "../../../Assets/AppComponent/icons/Role/Union.png";
import Security from "../../../Assets/AppComponent/icons/Role/Security.png";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { getBottomNavigationUtilityClass } from "@mui/material";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import useDebouncedEffect from 'use-debounced-effect';

const EmployeeListManager = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
   const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );

  const [barnchName, setBranchName] = useState();
  const [Zone, setZone] = useState();
  const [EmpInquiry, setInquiry] = useState();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.fieldagentPage?.page == undefined
      ? 1
      : TablePositionPersist.fieldagentPage.page
  );
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);
  const [newpages, setNewpage] = useState(1);
  const [search, setsearch] = useState(
    TablePositionPersist?.fieldagentPage?.search == undefined || TablePositionPersist?.fieldagentPage?.search == ""
      ? ""
      : TablePositionPersist.fieldagentPage.search
  );
  const [MakeCreate, setCreateBar] = useState(true);
  const [Filter, SetFilter] = useState(true);
  const [FilterHold, setFilterhold] = useState([]);
  const [FState, SetStates] = useState(false);
  const [RenderStatus, setRenderStatus] = useState();
  const [RoleOpions, setRoleOptions] = useState();

  ////--Role---id---state.NumberCounts.EmployeeRoleId
  ////---for the edit
  useEffect(() => {
    dispatch(setEditableActions(2));
  }, []);

  // ////-- dispatch --- the ----- client list
  // useEffect(()=>{
  //   dispatch(setTheBranchoptionsFieldAgent({value:"", label:"All"}))
  //   ///--- role------object --
  //    dispatch(setTheRoleObjects({value:"", label:"All"}))
  //      },[])

  ////--_FIlter--------------------------

  const options = [
    { value: state.NumberCounts.Option1, label: "All" },
    { value: state.NumberCounts.Option2, label: "Completed" },
    { value: state.NumberCounts.Option3, label: "Pending" },
    { value: state.NumberCounts.Option4, label: "Decline" },
    { value: state.NumberCounts.Option5, label: "Approved" },
  ];
  const [sel, setSelected] = useState();
  const [sno, setsno] = useState(0);

  ////----Count---Based------Rendered----
  const [Counting, setCounting] = useState(1);
  const [selectDisplay, setDisplay] = useState([]);
  const FileterState = {
    is_pending: state.NumberCounts?.SelectedValuesemplist?.is_pending,
    is_decline: state.NumberCounts?.SelectedValuesemplist?.is_decline,
    approved: state.NumberCounts?.SelectedValuesemplist?.approved,
  };
  const [RenderCounts, SetRenderCounts] = useState();
  const [selectVal, SetSelectval] = useState(FileterState);
  ///---Completed----Reders---------------------
  const FileterStatecom = {
    is_pending: false,
    is_decline: false,
    approved: "",
  };
  const [completed, setCompleted] = useState(FileterStatecom);

  //----Declines-------
  const FileterStateDecline = {
    is_pending: "",
    is_decline: true,
    approved: "",
  };
  const [Decline, setDecline] = useState(FileterStateDecline);
  ////--Pending
  //----Declines-------
  const FileterStatePending = {
    is_pending: true,
    is_decline: "",
    approved: "",
  };
  const [Pending, setPending] = useState(FileterStatePending);
  const [place, SetPlace] = useState("");

  const [BranchNameList, setBranchnamelIST] = useState();
  const [ListDatas, setListDatas] = useState({
    // ids: state.NumberCounts.EmployeeRoleId,
    ids: "",
    // client: state.NumberCounts.branchId,
    // client: "",
    client: state.NumberCounts.branchId,
  });
  const [Branchvalues, setBranchValues] = useState();
  const [RoleValues, setRoleValues] = useState();

  ///----Filter-----------------------

  const initialStateSearch = {
    
    RoleSearch: "",
    BranchSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    
    RoleSearch: "",
    BranchSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  const handleInputChangeBranch = (Val) => {
  
    setSearchDebounance({
      ...SearchDebounance,
      BranchSearch:Val
    })
  };


  const handleInputChangeRole = (Val) => {
    console.log(Val, "Values");
    setSearchDebounance({
      ...SearchDebounance,
      RoleSearch:Val
    })
  };

  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                RoleSearch: SearchDebounance.RoleSearch,
                BranchSearch: SearchDebounance.BranchSearch,
            });
        }
    },
    500,
    [SearchDebounance]
);
 
  useEffect(() => {
    // if (ListDatas.client != "") {
    const payloads = {
      search: SearchedVal.RoleSearch,
      page_size: "20",
      page: 1,
      mode: "all",
      // client: ListDatas.client,
      client: state.NumberCounts.branchId,
      // client:state.NumberCounts.BranchObjectFieldAgent?.value?.value ,
      // client:state.NumberCounts.branchId,
      white_collar: false,
    };
    dispatch(getRoleListActions(payloads));
    // }
  }, [
    // state.NumberCounts.branchId
    SearchedVal.RoleSearch,
    // state.NumberCounts.BranchObject
    // state.NumberCounts.branchId
    ListDatas.client
  ]);

  useEffect(() => {
    const Datas = [];

    if (
      // ListDatas.client != ""  &&
      state.rolelists.RoleList != undefined
    ) {
      let objectArray = [];
      // objectArray.push({ value: "", label: "All" });
      state.rolelists.RoleList.forEach((element) => {
        objectArray.push({ value: element.id, label: element.role.toUpperCase() });
      });
      // console.log(state.rolelists.RoleList, "roless");

      setRoleOptions(objectArray);
    }
  }, [state.rolelists, SearchedVal.RoleSearch, ListDatas.client]);
  console.log(SearchedVal.BranchSearch, "BranchSearch");
  ///---------------Branch---APi
  useEffect(() => {
    const payload = {
      search: SearchedVal.BranchSearch,
      page_size: "20",
      page: 1,
    };
    dispatch(setThefieldAgentbranchactions(payload)); ///----branch--------
  }, [
    SearchedVal.BranchSearch
  ]);

  useEffect(() => {

    if (state.fieldagentBracnhdata.fieldagentBranchDatas != undefined) {
    // if(state.NumberCounts.BranchObjectFieldAgent != undefined) { 
      console.log(state.fieldagentBracnhdata.fieldagentBranchDatas, "fieldagentBranchDatas");
      let objectArray = [];
      // objectArray.push({value :"" ,label:"All"})

      state.fieldagentBracnhdata.fieldagentBranchDatas.forEach((element) => {
        if (element.client_name != null) {
        objectArray.push({
          value: element.id,
          label: element.branch_code
          ? `${element.branch_code}-${element.client_name.toUpperCase()}`
          : element.client_name.toUpperCase(),
                is_reliever:element?.is_reliever
        });
        }
      });
      console.log(objectArray, "329=0objectArray");

      setBranchnamelIST(objectArray);

   
    }
  }, [
    state.fieldagentBracnhdata.fieldagentBranchDatas,
    SearchedVal.BranchSearch,
  ]);

  useEffect(() => {
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options));
      SetPlace("All");
    }
    if (state.NumberCounts.namerednder == "completed") {
      dispatch(setTheoptions(options[0]));
      SetPlace("Completed");
    }
    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
    }
  }, [state.NumberCounts.namerednder]);
  // useEffect(() => {
  //   dispatch(setTheoptions(options));
  //   SetPlace("All");

  //   SetSelectval({
  //     ///Completed
  //     ...selectVal,
  //     is_pending: "",
  //     is_decline: "",
  //     approved: "",
  //   });
  // }, []);
  ///console.log(state.NumberCounts.Options, "listouted");
  ///=------Status----Render----
  useEffect(() => {
    console.log(state.NumberCounts.AllEmpoyeeListCOunts, "without Branch List");
    setRenderStatus(state.ClientBranchIDs.DashboardIDs);
  }, [state.ClientBranchIDs.DashboardIDs]);
   console.log(state.NumberCounts.SelectedValuesemplist , state.NumberCounts.EmployeeRoleId , "wy8ye82y83e sdfdm mcnmxcn");
  useEffect(() => {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      ids: state.NumberCounts.EmployeeRoleId,
      client: state.NumberCounts.branchId,
      selectVal: selectVal,
      // RenderStatus: RenderStatus,
    };
  // if (
  //     state.EmployeeListManagerPresons.Inquriy.length == 0 ||
  //     TablePositionPersist?.fieldagentPage?.search != search ||
  //     TablePositionPersist?.fieldagentPage?.ids != state.NumberCounts.EmployeeRoleId ||
  //     TablePositionPersist?.fieldagentPage?.client != state.NumberCounts.branchId ||
  //     // TablePositionPersist?.fieldagentPage?.selectVal != selectVal ||
  //     // TablePositionPersist?.fieldagentPage?.RenderStatus != RenderStatus ||
  //           TablePositionPersist?.fieldagentPage?.selectVal?.is_pending != selectVal?.is_pending ||
  //           TablePositionPersist?.fieldagentPage?.selectVal?.is_decline != selectVal?.is_decline ||
  //           TablePositionPersist?.fieldagentPage?.selectVal?.approved != selectVal?.approved ||

  //     TablePositionPersist?.fieldagentPage?.page != dtpageindex ||
  //     TablePositionPersist?.fieldagentPage?.isApproved
  //   ) {

    dispatch(
      setTablePositionPersist({ data: payloads, pageName: "fieldagentPage" })
    );
  dispatch(getEmployeeListcreatePersonsListed(payloads));
    setCounting(1);
  
    dispatch(SetSignaturePops(false)); //////---dispatch------------------------------------------signatures-----------
  // }
  }, [
    dtpageindex,
    search,
    state.NumberCounts.branchId,
    state.NumberCounts.EmployeeRoleId,
    selectVal
  ]);
  console.log(      state.EmployeeListManagerPresons.Inquriy.length == 0 || TablePositionPersist?.fieldagentPage?.search != search ||
      TablePositionPersist?.fieldagentPage?.ids != state.NumberCounts.EmployeeRoleId ||
      TablePositionPersist?.fieldagentPage?.client != state.NumberCounts.branchId ||
      TablePositionPersist?.fieldagentPage?.selectVal != selectVal ||
      // TablePositionPersist?.fieldagentPage?.RenderStatus != RenderStatus ||
      TablePositionPersist?.fieldagentPage?.page != dtpageindex 
 ,"aisudpoasi dpoasud", TablePositionPersist?.fieldagentPage?.page != dtpageindex , 
 TablePositionPersist?.fieldagentPage?.selectVal != selectVal ,

      TablePositionPersist?.fieldagentPage?.client != state.NumberCounts.branchId,
TablePositionPersist?.fieldagentPage?.search != search,
TablePositionPersist?.fieldagentPage , 
selectVal ,
state.NumberCounts.branchId,
state.NumberCounts.EmployeeRoleId,
search,
dtpageindex


);
  
  useEffect(() => {
    if (state.EmployeeListManagerPresons.Inquriy != undefined) {
      setdatas(state.EmployeeListManagerPresons.Inquriy);
    }
  }, [state.EmployeeListManagerPresons.Inquriy]);

  useEffect(() => {
    dispatch(getEmployeeBranchName(""));
    dispatch(getEmployeeBranchZones(""));
    dispatch(getEmployeeEReuestlist(""));
  }, []);
  useEffect(() => {
    if (state.NumberCounts.EmployeeRoleId) {
      setBranchName(state.EmployeeVerificationsNeed.BranchName);
      setZone(state.EmployeeVerificationsNeed.Zone);
      setInquiry(state.EmployeeVerificationsNeed.EmployeeRequst);
    }
  }, [state.NumberCounts.EmployeeRoleId]);
  console.log(ListDatas, "ListDatas");
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);

    }
  };
  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const handleEmployeeDetails = (id) => {
    ///---employee-----EDIT!!!
    dispatch(setTheRoleObjects({ value: id.user_id.user_role.id, label: id.user_id.user_role.role }));
    dispatch(SettheBracnhId(id.client_id.id));
    // dispatch(setTheZoneObjectinEmployeeList({value:element.zone_id.id , label:element.zone_id.zone_name}))


    dispatch(setTheemployeeRoleId(id.user_id.user_role.id))
dispatch(setTheBranchoptionsFieldAgent({
    value: id?.client_id?.id ?? "",
  label: id?.client_id?.branch_code
    ? `${id.client_id.branch_code} - ${id.client_id.client_name ?? ""}`
    : `${id?.client_id?.client_name ?? ""}`,
  is_reliever: id?.client_id?.is_reliever ?? false

}));////client and role objects
 // to make empty 
 
                   dispatch(setTheAadharBackSideImageDatas([]))
 
                   dispatch(setTheAadharFrontImageDatas(""))
                   dispatch(settheBankHolderName(""))
                   dispatch(settheIDverifycationanotherapidatasResponse("")); //////Id verified responses
                   dispatch(setTheAadharFristNumbers(""))
                   dispatch(setTHnUMBERSRESPONSES(""));
                   dispatch(setIDverifycationanotherapidatasReponsesError(""))
 
 



    dispatch(SetEmployeeProfileDetailsID(id.user_id.id));
    dispatch(SetISPendingDetails(id.is_pending));
    dispatch(SETBASICFORMcreatedetails(id.id)); ///-----dispatch  a time_line_id-----
    dispatch(SetStatusBTN(false));
    dispatch(setTheUser_ID(id.user_id.id));
    dispatch(setTheAllFormPdf(id.create_employee));
    dispatch(setTheApproveRequeststate(4))
     setTimeout(() => {
      dispatch(setTheZoneObjectinEmployeeList({ value: id.user_id?.zone_id[0]?.id, label: id.user_id?.zone_id[0]?.zone_name }))

    }, 200);
    dispatch(settheJobinfoBranchEmployeeProfile({ value: id.client_id.id, label: id.client_id.client_name , 
            is_reliever:id?.client_id?.is_reliever

    }))
    if (id.basic_info != null) {
      dispatch(SetBasiformsID(id.basic_info));
    }

    if (id.basic_info == null) {
      dispatch(SetBasiformsID(""));
    }

    if (id.address_details != null) {
      dispatch(SetAddressId(id.address_details));
    }

    if (id.address_details == null) {
      dispatch(SetAddressId(""));
    }

    if (id.job_description != null && id.job_description.id != null) {
      dispatch(SetJobOfferID(id.job_description.id));
    }

    if (id.job_description == null && id.job_description == undefined) {
      dispatch(SetJobOfferID(""));
    }

    if (id.id_verification != null && id.id_verification != "") {
      dispatch(SetIdVeriications(id.id_verification));
    }

    if (id.id_verification == null) {
      dispatch(SetIdVeriications(""));
    }

    if (id.bank_details != null && id.bank_details != "") {
      dispatch(setBankDetailsId(id.bank_details));
    }

    if (id.bank_details == null) {
      dispatch(setBankDetailsId(""));
    }

    if (id.education_details != null && id.education_details != "") {
      dispatch(SetEducationDetails(id.education_details));
    }

    if (id.education_details == null) {
      dispatch(SetEducationDetails(""));
    }

    if (id.employee_previous != null && id.employee_previous != "") {
      dispatch(SetPreviousEmployeeID(id.employee_previous));
    }

    if (id.employee_previous == null) {
      dispatch(SetPreviousEmployeeID(""));
    }

    if (id.family_details != null && id.family_details != "") {
      dispatch(setfamliydetailsid(id.family_details));
    }

    if (id.family_details == null) {
      dispatch(setfamliydetailsid(""));
    }

    if (id.esi_form != null && id.esi_form != "") {
      dispatch(SetEsiFormIdActions(id.esi_form));
    }

    if (id.esi_form == null) {
      dispatch(SetEsiFormIdActions(""));
    }

    if (id.declaration_form != null && id.declaration_form != "") {
      dispatch(SetDeclarationId(id.declaration_form));
    }

    if (id.declaration_form == null) {
      dispatch(SetDeclarationId(""));
    }

    navigate("/employeeprofile");
    // window.location.href = "/employeeprofile";
  };

  const HandleEmployeeListedits = (id) => {
    ///0------Employee---Edit-----
    dispatch(SetEmployeeProfileDetailsID(id.user_id.id));
    dispatch(SetISPendingDetails(id.is_pending));
    dispatch(SetStatusBTN(false));
    dispatch(setTheUser_ID(id.user_id.id));
    console.log(id, "cteayeEmploee");
    dispatch(setTheApproveRequeststate(4))
    dispatch(setTheRoleObjects({ value: id.user_id.user_role.id, label: id.user_id.user_role.role }));
    dispatch(SettheBracnhId(id.client_id.id));
    dispatch(setTheRoleObjects(
      { value: id.user_id.user_role.id, label: id.user_id.user_role.role }
    ))

     // to make empty 
     
                       dispatch(setTheAadharBackSideImageDatas([]))
     
                       dispatch(setTheAadharFrontImageDatas(""))
                       dispatch(settheBankHolderName(""))
                       dispatch(settheIDverifycationanotherapidatasResponse("")); //////Id verified responses
                       dispatch(setTheAadharFristNumbers(""))
                       dispatch(setTHnUMBERSRESPONSES(""));
                       dispatch(setIDverifycationanotherapidatasReponsesError(""))
     
     
    
    
    setTimeout(() => {
      dispatch(setTheZoneObjectinEmployeeList({ value: id.user_id?.zone_id[0]?.id, label: id.user_id?.zone_id[0]?.zone_name }))

    }, 200);
    dispatch(settheJobinfoBranchEmployeeProfile({ value: id.client_id.id, label: id.client_id.client_name , 
            is_reliever:id?.client_id?.is_reliever

    }))
  dispatch(setTheBranchoptionsFieldAgent({
      value: id?.client_id?.id ?? "",
    label: id?.client_id?.branch_code
      ? `${id.client_id.branch_code} - ${id.client_id.client_name ?? ""}`
      : `${id?.client_id?.client_name ?? ""}`,
    is_reliever: id?.client_id?.is_reliever ?? false
  
  }));////client and role objects
  
    dispatch(setTheemployeeRoleId(id.user_id.user_role.id))

    dispatch(setTheAllFormPdf(id.create_employee));
    if (id.basic_info != null) {
      dispatch(SetBasiformsID(id.basic_info));
    }

    if (id.basic_info == null) {
      dispatch(SetBasiformsID(""));
    }


    if (id.address_details != null) {
      dispatch(SetAddressId(id.address_details));
    }
    if (id.address_details == null) {
      dispatch(SetAddressId(""));
      dispatch(setTheAadharBackSideImageDatas([]))

    }
    if (id.job_description != null && id.job_description.id != null) {
      dispatch(SetJobOfferID(id.job_description.id));
    }
    if (id.job_description == null || id.job_description.id == null) {
      dispatch(SetJobOfferID(""));

    }
    if (id.id_verification != null && id.id_verification != "") {
      dispatch(SetIdVeriications(id.id_verification));
    }
    if (id.id_verification == null || id.id_verification == "") {
      dispatch(SetIdVeriications(""));
    }
    if (id.bank_details != null && id.bank_details != "") {
      dispatch(setBankDetailsId(id.bank_details));
    }

    if (id.bank_details == null || id.bank_details == "") {
      dispatch(setBankDetailsId(""));
      dispatch(setTheDataAsEncodedDataResponses([]))
    }


    if (id.education_details != null && id.education_details != "") {
      dispatch(SetEducationDetails(id.education_details));
    }


    if (id.education_details == null || id.education_details == "") {
      dispatch(SetEducationDetails(""));
    }
    if (id.employee_previous != null && id.employee_previous != "") {
      dispatch(SetPreviousEmployeeID(id.employee_previous));
    }

    if (id.employee_previous == null || id.employee_previous == "") {
      dispatch(SetPreviousEmployeeID(""));
    }

    if (id.family_details != null && id.family_details != "") {
      dispatch(setfamliydetailsid(id.family_details));
    }

    if (id.family_details == null || id.family_details == "") {
      dispatch(setfamliydetailsid(""));
    }

    if (id.esi_form != null && id.esi_form != "") {
      dispatch(SetEsiFormIdActions(id.esi_form));
    }

    if (id.esi_form == null || id.esi_form == "") {
      dispatch(SetEsiFormIdActions(""));
    }

    if (id.declaration_form != null && id.declaration_form != "") {
      dispatch(SetDeclarationId(id.declaration_form));
    }

    if (id.declaration_form == null || id.declaration_form == "") {
      dispatch(SetDeclarationId(""));
    }

    navigate("/employeeprofile");
  };
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };


  const columns = useMemo(
    () => [
 {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.id != undefined &&
            row.row.original.id != null
          ) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);
            return <p className="m-0">{lastFourDigits}</p>;
          }
        },
      },
//   {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
      {
        Header: "Employee Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div
                className="UserName"
                style={{ cursor: "pointer" }}
              //    onClick={(e) => {
              //   handleEmployeeDetails(row.row.original);
              //}}
              >
                {/* {row.row.original.user_id != undefined &&
              row.row.original.user_id != null &&
              row.row.original.user_id.user_image != undefined &&
              row.row.original.user_id.user_image != null &&
              row.row.original.user_id.user_image.media_url != undefined &&
              row.row.original.user_id.user_image.media_url != null ? (
                <div className="ProfilImg">
                  <img src={row.row.original.user_id.user_image.media_url} />
                </div>
              ) : (
                <div className="ProfilImg">
                  <img src={profile2} />
                </div>
              )} */}

                <div className="">
                  {row.row.original.user_id != undefined && row.row.original.user_id != null &&
                    row.row.original.user_id != ""
                    &&
                    row.row.original.user_id.first_name != undefined && row.row.original.user_id.first_name != null
                    &&
                    row.row.original.user_id.first_name != "" ?
                    <span>
                      {capitalizeFirstLetter(
                        row.row.original.user_id.first_name
                      )}
                    </span>
                    : <>--</>}
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: "Role",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.user_id.user_role.role != undefined ? (
                <div className="UserName">
                  <span>{row.row.original.user_id.user_role.role}</span>
                </div>
              ) : (
                <div className="UserName">
                  <span>---</span>
                </div>
              )}
            </>
          );
        },
      },
      {
        Header: "Created date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

          return (
            <>
              <span>
                {`${row.row.original.created_at.slice(0, 10) + "  " + formattedTime
                  }`}
              </span>
            </>
          );
        },
      },

      {
        Header: "Verification",
        accessor: "",
        Cell: (row) => {
              const isExited = row.row.original?.is_exited;

    if (isExited) {
      return (
        <p
          className="m-0"
          style={{ color: "#d9534f", fontWeight: 600 }}
        >
          Exited
        </p>
      );
    }

    
          return (
            <>
              {/* ////-----------------Decline---Status------For is_decline as   have to -true */}
              {row.row.original.create_employee && row.row.original.is_decline ? (
                <div className="StatusList">
                  <div className="DeclineStatus">
                    <span>x</span>
                  </div>
                  <span>Decline</span>
                </div>
              ) : (
                <>
                  {/* ////-----------------Approvel---Status------For Decline , is_pending  have to false and job_description.letter_id is should not 
                 be undefined
                */}
                  {!row.row.original.is_pending &&
                    !row.row.original.is_decline &&
                    row.row.original.job_description != undefined &&
                    row.row.original.job_description.letter_id != undefined &&
                    row.row.original.job_description.letter_id.media_url !=
                    undefined ? (
                    <div
                      className="StatusList"
                    >
                      <img src={correctIcons} />
                      <span>Approve</span>

                      {/* {row.row.original.job_description != undefined &&
                    row.row.original.job_description.letter_id != undefined &&
                    row.row.original.job_description.letter_id.media_url !=
                      undefined ? (
                      <a
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(
                            row.row.original.job_description.letter_id
                              .media_url,
                            "_blank"
                          );
                        }}
                      >
                        <i class="fa-solid fa-download"></i>
                      </a>
                    ) : null}
 */}
                    </div>
                  ) : (
                    <>
                      {/* ////-----------------Pending---Status------For is_pending  have to -true */}
                      {row.row.original.create_employee &&
                        row.row.original.is_pending ? (
                        <div className="StatusList">
                          <img src={Pendingimg} />
                          <span>Pending</span>
                        </div>
                      ) : (
                        <>
                          {/* ////-----------------completed---Status------For  Decline , is_pending  have to false */}
                          {row.row.original.create_employee &&
                            !row.row.original.is_pending &&
                            !row.row.original.is_decline ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>Completed</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                <button
                  className=" btn Status"
                  component="span"
                  onClick={(e) => {
                    HandleEmployeeListedits(row.row.original);
                  }}
                >
                  <span className="OuterActionSpan">
                    <span className="EditImages">
                      <img src={EditImages} />
                    </span>
                    <span className="ActionsList"> Edit </span>
                  </span>
                </button>

              </div>
            </>
          );
        },
      },


    ],
    [sno]
  );
  //--------_____Filter-----------Based---On----Status--

  const count = (Counts, values, sel, SelectedValues) => {
    SetRenderCounts(Counts);
    // console.log(Counts, values, sel, "Logs");
    console.log(SelectedValues, "selectedvaluess", values);
    setDisplay(SelectedValues);
    setCounting(2);
    setSelected(sel);
    SetStates(true);
    dispatch(setTheoptions(SelectedValues));
    dispatch(setThecountBasedRenders(2));
    dispatch(settheSelectedemployeeliststatust(SelectedValues))
    if (values == "All") {
      ///All
      SetRenderCounts(1);
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: "",
        is_decline: "",
        approved: "",
      });
      dispatch(settheSelectedValuesemplist(
        {
          is_pending: "",
          is_decline: "",
          approved: "",
        }
      ))
      // const payloads = {
      //   search: "",
      //   page_size: 20,        page: currentPage,
      //   ids: state.NumberCounts.EmployeeRoleId,
      //   client: state.NumberCounts.branchId,
      //   // ids: ListDatas.ids,
      //   // client: ListDatas.client,
      //   selectVal: { is_pending: "", is_decline: "", approved: "" },
      //   RenderStatus: RenderStatus,
      // };
      // dispatch(getEmployeeListcreatePersonsListed(payloads));
      // setCounting(1);
    }

    if (values == "Completed") {
      dispatch(settheSelectedValuesemplist(
        {
          is_pending: false,
          is_decline: false,
          approved: "",
        }
      ))
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: false,
        is_decline: false,
        approved: "",
      });
      setCounting(2);
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        is_pending: true,
        is_decline: "",
        approved: "",
      });
      dispatch(settheSelectedValuesemplist(
        {
          is_pending: true,
          is_decline: "",
          approved: "",
        }
      ))
      setCounting(2);
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
      });

      dispatch(settheSelectedValuesemplist(
        {
          is_decline: true,
          is_pending: "",
          approved: "",
        }
      ))
      setCounting(2);
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        is_decline: "",
        is_pending: "",
        approved: true,
      });
      dispatch(settheSelectedValuesemplist(
        {
          is_decline: "",
          is_pending: "",
          approved: true,
        }
      ))
      setCounting(2);
    }
  };

  let objectArray = [];

  options.map((item) => {
    if (
      item.value == 1 &&
      // state.ClientBranchIDs.DashboardIDs == 2 &&
      state.NumberCounts.namerednder == ""
    ) {
      objectArray.push({ value: item.value, label: item.label });
    } else if (
      item.value == 1 &&
      state.NumberCounts.namerednder == "completed"
    ) {
      objectArray.push({ value: item.value, label: item.label });
    } else if (item.value == 1 && state.NumberCounts.namerednder == "Decline") {
      objectArray.push({ value: item.value, label: item.label });
    }
  });

  const ClearState = (Counts) => {
    SetSelectval({
      ///Completed
      ...selectVal,
      is_pending: "",
      is_decline: "",
      approved: "",
    });
    // console.log(state.NumberCounts.EmployeeRoleId, "jojijojj");
    dispatch(settheSelectedValuesemplist(
      {
        is_pending: "",
        is_decline: "",
        approved: "",
      }
    ))

    dispatch(settheSelectedemployeeliststatust({value:'1',label:"All"}))

  };


  useEffect(() => {
    setFilterhold(
      state.EmployeeListfilterPresons.EmployeePersonsFIlter.inquiry_data
    );
  }, [selectVal.is_pending, selectVal.is_decline, Counting]);


  useEffect(() => {
    if (state.fieldagentBracnhdata.fieldagentBranchDatas != undefined && state.NumberCounts.BranchObjectFieldAgent.value != "") {
      console.log(state.fieldagentBracnhdata.fieldagentBranchDatas, "fieldagentBranchDatas");

      state.fieldagentBracnhdata.fieldagentBranchDatas.forEach((element) => {

        if (element.client_name != null) {


          if (state.NumberCounts.BranchObjectFieldAgent.value == element.id
            // || state.NumberCounts.BranchObjectFieldAgent.value == state.NumberCounts.BranchObjectFieldAgent.value
          ) {

            if (element.zone_id != null && element.zone_id != undefined) {

               console.log("asdiusaiud ", element);
               
              // console.log(element.zone_id , element.zone_id.id , "23789208709element");
              dispatch(setTheZoneObjectinEmployeeList({ value: element.zone_id.id, label: element.zone_id.zone_name }))
            }
          }
        }
      });
    }

  }, [state.NumberCounts.BranchObjectFieldAgent,
  state.NumberCounts.branchId
  // FState

  ])

  const FetchingAPICALLS =()=>{
                                        // navigate("/employeeprofile");
const payloads  = {
     params:{
         designation_id: state.NumberCounts.EmployeeRoleId,
      client_id: state.NumberCounts.branchId,
     },
   Funcations: () => {
          // Your function logic here
          console.log('Function called');
          navigate("/employeeprofile")

        },
}
    dispatch(resetLimitationActions_opretions(payloads))
  }
  //  console.log(state.NumberCounts.employeeliststatus ,"spodi employeeliststatus", state.NumberCounts.ZONEobjects); 
      const currentRef = useRef();
   const scrollPosition = (e) => {
     const val = currentRef.current.scrollTop;
     sessionStorage.setItem("fieldagentTableScrollPosition", val);
   };


  return (
    <>
      <div 
            onScroll={scrollPosition}
      ref={currentRef}

      
      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Employee List </h3>

          </div>

          <div className="Add-User col-sm-5">
            <button
              className="ButtonCSS"
              onClick={(e) => {
                if (
                  state.NumberCounts.EmployeeRoleId != "" &&
                  state.NumberCounts.branchId != ""
                ) {
                  dispatch(setTheAllFormPdf(false));

                  dispatch(setEditableActions(2));
                  dispatch(setEmployeeListProfileSResponseActions("")); ///--RTo--Make---kyc--employee-datas--in form--data--as--empty
                  dispatch(SETBASICFORMcreatedetails(""));
                  dispatch(setTheUser_ID(""));
                  ///-----id , is-pending-button
                  dispatch(SetEmployeeProfileDetailsID(""));
                  dispatch(SetISPendingDetails(""));
                  dispatch(SetStatusBTN(false));
                  dispatch(SetBasiformsID(""));
                  dispatch(SetAddressId(""));
                  dispatch(SetJobOfferID(""));
                  dispatch(SetIdVeriications(""));
                  dispatch(setBankDetailsId(""));
                  dispatch(SetEducationDetails(""));
                  dispatch(SetPreviousEmployeeID(""));
                  dispatch(setfamliydetailsid(""));
                  dispatch(SetEsiFormIdActions(""));
                  dispatch(SetDeclarationId(""));
                  dispatch(setAadhar_counts(0));
                  dispatch(setTheAadhar_front_count(0));
                  dispatch(setTheAadharBack_counts(0));
                  dispatch(setThPanVerifyCounts(0));
                  dispatch(setThePanFrontCOunt(0));
                  dispatch(setbankCounts(0));
                  // dispatch(setTheemployeeRoleId(""));
                  dispatch(setTheApproveRequeststate(4))
                  dispatch(setTheAadharBackSideImageDatas([]))

                  dispatch(setThePANCARDotpResponsiveDatas(false));
                  dispatch(CreateResponse_store(false));
                  dispatch(setTheFirstNames(""))
                  dispatch(setTheAadharFrontImageDatas(""))
                  dispatch(settheBankHolderName(""))
                  dispatch(settheIDverifycationanotherapidatasResponse("")); //////Id verified responses
                  dispatch(setTheAadharFristNumbers(""))
                  dispatch(setTHnUMBERSRESPONSES(""));
                  dispatch(setIDverifycationanotherapidatasReponsesError(""))
FetchingAPICALLS()


                } else {
                  toast.error(
                    ` ${"Please select the client name and designation for which you want to create the entry"} `,
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    }
                  );
                }
              }}
            >
              Create
            </button>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",


            marginLeft: "0px",
            marginRight: "0px",
            // top: "-20px",
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Client List
            </label>
            <span style={{ color: "red" }}>*</span>

            <Select
              styles={{ position: "relative", top: "60px" }}
              // isClearable={true}
              className="Selects"
              filterOption={() => true}
              onChange={(e) => {
                setRoleValues([]);
                dispatch(setTheemployeeRoleId(""));
                console.log(e, "293842930");

                setdtPageindex(1);
                if (e != null && e.value != null && e.label.trim() != "") {
                  dispatch(SettheBracnhId(e.value));


                  setListDatas({
                    ...ListDatas,
                    client: e.value,
                    ids: "",
                  });

                  setBranchValues(e);

                  // dispatch(getEmployeeBranchName(e.label))
                  dispatch(
                    setTheBranchoptionsFieldAgent({ value: e.value, label: e.label })
                  );
                  dispatch(settheJobinfoBranchEmployeeProfile({ value: e.value, label: e.label,is_reliever:e?.is_relieve }))

                  dispatch(setTheRoleObjects({ value: "", label: "Select" }));
                } else if (e == null) {
                  setListDatas({
                    ...ListDatas,
                    client: "",
                    ids: "",
                  });

                  setBranchValues();

                  dispatch(SettheBracnhId(""));
                  // dispatch(getEmployeeBranchName(e.label))
                  dispatch(setTheBranchoptionsFieldAgent({ value: "", label: "Select" , is_relieve:false}));
                  dispatch(settheJobinfoBranchEmployeeProfile({ value: "", label: "Select",      is_reliever:false }));

                  dispatch(setTheRoleObjects({ value: "", label: "Select" }));

                  // dispatch(setTheBranchoptionsFieldAgent({ value: "", label: "All" }));
                }

                // console.log(state.NumberCounts.BranchObject, "BranchObject");
                dispatch(setEditableActions(2));
                dispatch(setTheRoleRemoveFilters(2));
                dispatch(setaRoleChnage(2)); ///---to remove--a actions---and create----
              }}
              options={BranchNameList}
              value={state.NumberCounts.BranchObjectFieldAgent}
              // value={Branchvalues}
              onInputChange={handleInputChangeBranch}
              placeholder={"Select..."}
              isClearable={true}
            />
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Designation
            </label>
            <Select
              className="Selects"
              // isClearable={true}
              styles={{ position: "relative", top: "60px" }}
              options={RoleOpions}
              labelledBy="SELECT"
              onChange={(e) => {
                setdtPageindex(1);
                if (e != null) {
                  dispatch(
                    setTheRoleObjects({ value: e.value, label: e.label })
                  );

                  setListDatas({
                    ...ListDatas,
                    ids: e.value,
                  });
                  setRoleValues(e);
                  dispatch(setTheemployeeRoleId(e.value));
                  dispatch(setthejobinformationroleID(e.value));
                } else if (e == null) {
                  setListDatas({
                    ...ListDatas,
                    ids: "",
                  });
                  setRoleValues();

                  dispatch(setTheemployeeRoleId(""));
                  dispatch(setthejobinformationroleID(""));

                  dispatch(setTheRoleObjects({ value: "", label: "Select" }));

                  // dispatch(setTheRoleObjects({ value: "", label: "All" }));
                }

                //  dispatch(setTheGrossSalary(e.salary));
              }}
              isClearable={true}
              value={state.NumberCounts.RoleOjects}
              // value={RoleValues}
              onInputChange={handleInputChangeRole}
              placeholder={"SELECT"}
            />
          </div>
        </div>

        {/* <div className="Branch-Details">
          <div className="innerListBranchDATAS">
            <div className="ICONS">
              <div>
                <img src={clientimg} />
              </div>
              <span>
                {state.NumberCounts.BranchObject.label != "All"
                  ? state.NumberCounts.BranchObject.label
                  : ""}
              </span>
            </div>
            <div className="ICONS">
              <div>
                <img src={Regionicons} />
              </div>
              <span>{Zone}</span>
            </div>
            <div className="ICONS">
              <div>
                <img src={empployeeIcons} />
              </div>
              <span>{EmpInquiry} Employees</span>
            </div>
          </div>
        </div> */}

        <div style={{ padding: " 10px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={
              // Counting == 1
              // ? state.EmployeeListManagerPresons.Inquriy
              Data
            }
            //data={
            //Counting == 1 ?
            //  Data
            // : FilterHold
            // }
            columns={columns}
            totalItems={
              // Counting == 1
              //   ? state.EmployeeListManagerPresons.Total_Count
              state.EmployeeListManagerPresons.Total_Count
            }
            currentPage={currentPage}
            // onPageChange={handlePageChange}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            GotoEnteredPage={GotoEnteredPage}

            datacount={
              // Counting == 1
              // ? state.EmployeeListManagerPresons.Total_Count
              state.EmployeeListManagerPresons.Total_Count
            }
            MakeCreate={MakeCreate}
            ViewParts={(e) => {
              handleEmployeeDetails(e);
            }}
            // values={Counting == 1 || Counting == 2 ? objectArray :
            //
            // state.NumberCounts.namerednder == "Decline" ||
            // state.NumberCounts.namerednder == "completed"
            // ?
            // objectArray: selectDisplay
            //
            // }
            // values={Counting == 1 ? objectArray : selectDisplay}

            values={state.NumberCounts.employeeliststatus}
            options={options}
            Filter={Filter}
            count={count}
            ClearState={ClearState}
            placeHold={place}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            ApproveRequestFilter={true}
            searchVal={TablePositionPersist?.fieldagentPage?.search == "" || TablePositionPersist?.fieldagentPage?.search ==undefined? "":TablePositionPersist.fieldagentPage.search}
              search_key={true}

   


          />
        </div>
      </div>

      <>

      </>
    </>
  );
};

export default EmployeeListManager;
